// import './client'
import KrealabModal from "./elements/KrealabModal";
import KrealabAjaxForm from './elements/KrealabAjaxForm';

new KrealabModal();

jQuery(function($){
    new KrealabAjaxForm($);
});


/* Swiper News home*/
var swiper = new Swiper(".news-home", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 30,
            loop: false,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter : true,
            },
        },

        // when window width is >= 769px
        769: {
            slidesPerView: 3,
            spaceBetween: 30,
            loop: false,
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter : true,
            },
        },
    }
});


/*Remove Clip-path if Beaver loaded */
jQuery(function ($) {  
    if ($('body').hasClass('fl-builder-edit')) {
        $('#gammes').css('clip-path','none');
        $('#fundamentals').css('clip-path','none'); 
        $('#contact').css('clip-path','none'); 
    }
});

/*Hide arrows if emptynews */
jQuery(function ($) { 
    if($('.empty-news').length) {
        $('.swiper-button-next').hide();
        $('.swiper-button-prev').hide();
    }
});